export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-location-c733ee38641962fed5ec093eca8a02d0.jpg";